import { render, staticRenderFns } from "./BaseFile.vue?vue&type=template&id=2ab77180"
import script from "./BaseFile.vue?vue&type=script&lang=js"
export * from "./BaseFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports